export default __webpack_public_path__ + "static/media/StarPage2.fdbc85bc.txt";